import React, { Component } from 'react';
import { connect } from 'react-redux';
import 'components/admin/general-contractors/GeneralContractorOnboarding.css';
import { getCurrentStage } from 'components/admin/general-contractors/store/selectors';
import { newOnboarding } from 'components/admin/general-contractors/store/actions';
import LicenceNumberInput from 'components/admin/general-contractors/LicenceNumberInput';
import CompanyLogoUpload from 'components/admin/general-contractors/CompanyLogoUpload';

class GeneralContractorOnboarding extends Component {
  constructor(props) {
    super(props);

    props.dispatch(newOnboarding());
  }

  renderCurrentStage = () => {
    let stage;

    switch (this.props.currentStage) {
      case 'licence-input':
        stage = <LicenceNumberInput />;
        break;

      case 'logo-upload':
        stage = <CompanyLogoUpload />;
        break;

      default:
        stage = null;
    }

    return stage;
  };

  render() {
    return (
      <div className="general-contractor-onboarding">
        {this.renderCurrentStage()}
      </div>
    );
  }
}

export default connect((state) => {
  return {
    currentStage: getCurrentStage(state),
  };
})(GeneralContractorOnboarding);



// WEBPACK FOOTER //
// ./src/components/admin/general-contractors/GeneralContractorOnboarding.js